import { isBrandBoxId } from "../../../../common/brand_box_id";

// Boxes have no z-index of their own — they stack by DOM order — so any
// positive value lifts the selection above every sibling, while staying far
// below the editor chrome (box icons / overlays at 9999).
export const SELECTION_LIFT_Z = 50;

// Brand kit assets (a logo on every scene) stay on top even while another box
// is selected and lifted. The data keeps them last in `.boxes` too
// (reducers/keepBrandAssetsOnTop.js), which is what the Visor and exports use.
export const BRAND_ASSET_Z = SELECTION_LIFT_Z + 1;

/** z-index a box renders with; undefined = plain DOM order. */
export function boxZIndex(id, isSelected) {
  if (isBrandBoxId(id)) return BRAND_ASSET_Z;
  return isSelected ? SELECTION_LIFT_Z : undefined;
}
